import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  QuotationListReq,
  QuotationListRes,
  CreateQuotationReq,
  ActionQuotationRes,
  UpdateQuotationReq,
  DeleteQuotationReq,
  QuotationDetailReq,
  QuotationDetailRes,
  UpdateQuotationStatusReq,
  CustomerReq,
  CustomerRes,
  UpdateGrnReq,
  CountRes,
} from './types'

export const getQuotationListAction = createAsyncAction(
  'QUOTATION/GET_QUOTATION_LIST_REQ',
  'QUOTATION/GET_QUOTATION_LIST_SUCCESS',
  'QUOTATION/GET_QUOTATION_LIST_FAILURE',
)<QuotationListReq, QuotationListRes, Error>()

export const getQuotationDetailAction = createAsyncAction(
  'QUOTATION/GET_QUOTATION_DETAIL_REQ',
  'QUOTATION/GET_QUOTATION_DETAIL_SUCCESS',
  'QUOTATION/GET_QUOTATION_DETAIL_FAILURE',
)<QuotationDetailReq, QuotationDetailRes, Error>()

export const createQuotationAction = createAsyncAction(
  'QUOTATION/CREATE_QUOTATION_REQ',
  'QUOTATION/CREATE_QUOTATION_SUCCESS',
  'QUOTATION/CREATE_QUOTATION_FAILURE',
)<CreateQuotationReq, ActionQuotationRes, Error>()

export const updateQuotationAction = createAsyncAction(
  'QUOTATION/UPDATE_QUOTATION_REQ',
  'QUOTATION/UPDATE_QUOTATION_SUCCESS',
  'QUOTATION/UPDATE_QUOTATION_FAILURE',
)<UpdateQuotationReq, ActionQuotationRes, Error>()

export const deleteQuotationAction = createAsyncAction(
  'QUOTATION/DELETE_QUOTATION_REQ',
  'QUOTATION/DELETE_QUOTATION_SUCCESS',
  'QUOTATION/DELETE_QUOTATION_FAILURE',
)<DeleteQuotationReq, ActionQuotationRes, Error>()

export const updateQuotationStatusAction = createAsyncAction(
  'QUOTATION/UPDATE_QUOTATION_STATUS_REQ',
  'QUOTATION/UPDATE_QUOTATION_STATUS_SUCCESS',
  'QUOTATION/UPDATE_QUOTATION_STATUS_FAILURE',
)<UpdateQuotationStatusReq, ActionQuotationRes, Error>()

export const getCustomerAction = createAsyncAction(
  'QUOTATION/GET_ORDER_CUSTOMER_REQ',
  'QUOTATION/GET_ORDER_CUSTOMER_SUCCESS',
  'QUOTATION/GET_ORDER_CUSTOMER_FAILURE',
)<CustomerReq, CustomerRes, Error>()

export const updateGrnQuotationAction = createAsyncAction(
  'QUOTATION/UPDATE_GRN_QUOTATION_REQ',
  'QUOTATION/UPDATE_GRN_QUOTATION_SUCCESS',
  'QUOTATION/UPDATE_GRN_QUOTATION_FAILURE',
)<UpdateGrnReq, ActionQuotationRes, Error>()

export const getCountAction = createAsyncAction(
  'QUOTATION/GET_COUNT_REQ',
  'QUOTATION/GET_COUNT_SUCCESS',
  'QUOTATION/GET_COUNT_FAILURE',
)<{}, CountRes, Error>()

export const clearEventAction = createStandardAction('QUOTATION/CLEAR_EVENT')<void>()
